import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconVimeo32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconVimeo32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M26.99 11.398q-.144 3.205-4.483 8.78-4.498 5.82-7.6 5.822-1.923 0-3.253-3.546L9.88 15.955q-.99-3.545-2.12-3.546-.247 0-1.724 1.034L5 12.113a304 304 0 0 0 3.208-2.85q2.175-1.873 3.26-1.972 2.565-.246 3.16 3.507.64 4.046.879 5.041.744 3.358 1.63 3.356.692 0 2.073-2.18 1.38-2.178 1.48-3.315.199-1.879-1.48-1.88a4.1 4.1 0 0 0-1.627.359q1.629-5.322 6.201-5.175 3.39.103 3.207 4.394"
            />
        </svg>
    );
}
export default memo(IconVimeo32);
